// import get from 'lodash/get';
import { handleError } from 'helper/rest';
import { client } from 'helper/axios';

export const getCustomerAll = async ({ token, params }: any) => {
  try {
    return await client
      .get(`customer`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const getCustomerMyGroupUserAll = async ({ token, params }: any) => {
  try {
    return await client
      .get(`customer/mygroup_user`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const getCustomerById = async ({ token, params }: any) => {
  try {
    return await client
      .get(`customer/${params?.id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const postCreateCustomer = async ({ token, params }: any) => {
  try {
    return await client
      .post(`customer`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const putUpdateCustomer = async ({ token, params, id }: any) => {
  try {
    return await client
      .put(`customer/${id}`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const putUpdateChangePassword = async ({ token, params, id }: any) => {
  try {
    return await client
      .put(`customer/${id}/changepassword`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const deleteCustomer = async ({ token, id }: any) => {
  try {
    return await client
      .delete(`customer/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const putBlockCustomer = async ({ token, params, id }: any) => {
  try {
    return await client
      .put(`customer/${id}/blockuser`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const putUnBlockCustomer = async ({ token, id }: any) => {
  try {
    return await client
      .put(
        `customer/${id}/unblockuser`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const putReturnCreditsCustomer = async ({ token, params, id }: any) => {
  try {
    return await client
      .put(`customer/${id}/returncreditsuser`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const putUnlockReturnCreditsCustomer = async ({ token, id }: any) => {
  try {
    return await client
      .put(
        `customer/${id}/returnunlockcreditsuser`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const getCustomerByTypeAndCheckPayrate = async ({ token, params }: any) => {
  try {
    return await client
      .get(`customer_check_price`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const getCustomerCheckByGroup = async ({ token, params }: any) => {
  try {
    return await client
      .get(`customer_check_by_group`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const postCreateCustomerUserListStaff = async ({ token, params }: any) => {
  try {
    return await client
      .post(`customer_user_list_staff`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const getUserStaffActiveData = async ({ token, params }: any) => {
  try {
    return await client
      .get(`customer_staff_active_data/${params?.staff_id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const getCustomerByStaffId = async ({ token, params }: any) => {
  try {
    return await client
      .get(`customer_by_staff_id`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const putUpdateCreditsLimit = async ({ token, params, id }: any) => {
  try {
    return await client
      .put(`customer/${id}/credits_limit`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const putUpdateCredits = async ({ token, params, id }: any) => {
  try {
    return await client
      .put(`customer/${id}/credits`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const updateStatusDealer = async ({ token, params, id }: any) => {
  try {
    return await client
      .put(`customer/${id}/dealer_status`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const getCustomerTypeUserGroup = async ({ token, params }: any) => {
  try {
    return await client
      .get(`customer_type_user_by_group/${params?.type}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const getCustomerOwnerAll = async ({ token, params }: any) => {
  try {
    return await client
      .get(`customer_owner`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const getCustomerOwnerInactiveAll = async ({ token, params }: any) => {
  try {
    return await client
      .get(`customer_owner_inactive`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const deleteCustomerOwnerInactive = async ({ token, id }: any) => {
  try {
    return await client
      .delete(`customer_owner_inactive/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const getCustomerOwnerTopup = async ({ token, params }: any) => {
  try {
    return await client
      .get(`customer_owner_top_up`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};
export const getCustomerOwnerReport = async ({ token, params }: any) => {
  try {
    return await client
      .get(`customer_owner_used_data`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const getCustomerOwnerReportPrevious = async ({ token, params }: any) => {
  try {
    return await client
      .get(`customer_owner_used_data_previous`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const getCustomerOwnerReportCurrent = async ({ token, params }: any) => {
  try {
    return await client
      .get(`customer_owner_used_data_current`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const getCustomerOwnerSummary = async ({ token, params }: any) => {
  try {
    return await client
      .get(`customer_owner_used_data_table`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const getCustomerOwnerInReportById = async ({ token, params }: any) => {
  try {
    return await client
      .get(`customer_owner_in_report/${params?.id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const getCustomerCheckUsername = async ({ token, params }: any) => {
  try {
    return await client
      .get(`customer_check_username`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const getCustomerOwnerInReportGoverment = async ({ token, params }: any) => {
  try {
    return await client
      .get(`customer_owner_in_report_goverment`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};
